import React, {ReactNode} from 'react';

import {floatPriceFromFormatted} from '@optimaxdev/utils';
import classNames from 'classnames';

import {Price} from 'components/price/price';
import {BaseItemPrice} from 'desktop/components/baseItemPrice/baseItemPrice';

import s from './baseInfoRow.scss';

export type PropsType = {
    title: ReactNode;
    label?: ReactNode;
    link?: ReactNode;
    postfix?: ReactNode;
    price?: Maybe<number | string>;
    specialPrice?: Maybe<number | string>;
    description?: ReactNode;
    heading?: boolean;
    dataTestName?: Maybe<string>;
    dataTestValue?: Maybe<string>;
    showDiscount?: boolean;
};

/**
 * Info block for item in cart
 * @param {PropsType} props - component props
 * @returns {React.ReactElement} - info block component
 */
export const BaseInfoRow = ({
    dataTestName = null,
    dataTestValue = null,
    description = null,
    heading = false,
    label = null,
    link = null,
    postfix = null,
    price = null,
    showDiscount = true,
    specialPrice = null,
    title = null,
}: PropsType) => {
    const formattedPrice = floatPriceFromFormatted(String(price));

    return (
        <div
            className={classNames(s.row, {
                [s.heading]: heading,
            })}
            data-test-name={dataTestName}
            data-test-value={dataTestValue}
        >
            <div className={s.line}>
                <div className={s.titleWrapper}>
                    {label && <span className={s.label}>{label}</span>}
                    <span className={s.title}>{title}</span>
                    {formattedPrice > 0 && (
                        <span className={s.price}>
                            (
                            {showDiscount ? (
                                <BaseItemPrice price={formattedPrice} specialPrice={specialPrice} />
                            ) : (
                                <Price>{specialPrice}</Price>
                            )}
                            )
                        </span>
                    )}
                    {link && <span className={s.link}>{link}</span>}
                    {postfix}
                </div>
            </div>
            {description && <div className={s.desc}>{description}</div>}
        </div>
    );
};
